import * as CiWorkflow from '@banking/ui/workflows/onboarding-ci';
export const MAX_OWNERSHIP_BPS = 10_000;
export const OTHER_OWNERS_BREAKPOINT_BPS = 7_500;
export let State;
(function (_State) {
  let Screen = /*#__PURE__*/function (Screen) {
    Screen["None"] = "NONE";
    Screen["BusinessType"] = "BUSINESS_TYPE";
    Screen["BusinessAddress"] = "BUSINESS_ADDRESS";
    Screen["EntityType"] = "ENTITY_TYPE";
    Screen["BusinessManagement"] = "BUSINESS_MANAGEMENT";
    Screen["ControllingIndividuals"] = "CONTROLLING_INDIVIDUALS";
    return Screen;
  }({});
  _State.Screen = Screen;
})(State || (State = {}));
const INITIAL_STATE = {
  done: false,
  loading: false,
  businessName: '',
  taxId: {},
  screen: State.Screen.None,
  individuals: [],
  ciState: CiWorkflow.createState(),
  reviewBusinessAddress: false
};
export const createState = (overrides = {}) => ({
  ...INITIAL_STATE,
  ...overrides
});
export function shouldShowControllingIndividualsScreen(state) {
  return Boolean(!state.isManager || state.hasSignificantOwners);
}